export default {
  searchCounter: 0,
  freeSearchLimit: 10,
};
